import { render, staticRenderFns } from "./porposal-pending-evaluations.vue?vue&type=template&id=4223c278&"
import script from "./porposal-pending-evaluations.vue?vue&type=script&lang=ts&"
export * from "./porposal-pending-evaluations.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-pending-evaluations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports